// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/sandbox/v2/service.proto (package chalk.sandbox.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { TagFilter } from "../../common/v1/tag_filter_pb";
import { file_chalk_common_v1_tag_filter } from "../../common/v1/tag_filter_pb";
import type { ChalkContainerSpec } from "../../container/v1/service_pb";
import { file_chalk_container_v1_service } from "../../container/v1/service_pb";
import { file_chalk_flags_v1_flags } from "../../flags/v1/flags_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/sandbox/v2/service.proto.
 */
export const file_chalk_sandbox_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_common_v1_tag_filter, file_chalk_container_v1_service, file_chalk_flags_v1_flags, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.sandbox.v2.SandboxInfo
 */
export type SandboxInfo = Message<"chalk.sandbox.v2.SandboxInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: chalk.sandbox.v2.SandboxStatus status = 3;
   */
  status: SandboxStatus;

  /**
   * Top-level summary for the current status.
   *
   * @generated from field: optional string status_message = 4;
   */
  statusMessage?: string;

  /**
   * @generated from field: chalk.container.v1.ChalkContainerSpec spec = 5;
   */
  spec?: ChalkContainerSpec;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp finished_at = 7;
   */
  finishedAt?: Timestamp;

  /**
   * @generated from field: optional string web_url = 8;
   */
  webUrl?: string;

  /**
   * Cloud region of the stored sandbox cluster. Empty when unknown.
   *
   * @generated from field: string region = 9;
   */
  region: string;

  /**
   * User or service-token ID, absent when the creator is unknown.
   *
   * @generated from field: optional string created_by = 10;
   */
  createdBy?: string;

  /**
   * Additional diagnostic info for status_message.
   *
   * @generated from field: optional string status_details = 11;
   */
  statusDetails?: string;

  /**
   * Cluster where this sandbox is placed.
   *
   * @generated from field: string cluster_id = 12;
   */
  clusterId: string;

  /**
   * Snapshot used at initial creation; unchanged by resume. Absent when not recorded.
   *
   * @generated from field: optional string created_from_snapshot_id = 13;
   */
  createdFromSnapshotId?: string;
};

/**
 * Describes the message chalk.sandbox.v2.SandboxInfo.
 * Use `create(SandboxInfoSchema)` to create a new message.
 */
export const SandboxInfoSchema: GenMessage<SandboxInfo> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 0);

/**
 * @generated from message chalk.sandbox.v2.CreateSandboxRequest
 */
export type CreateSandboxRequest = Message<"chalk.sandbox.v2.CreateSandboxRequest"> & {
  /**
   * @generated from oneof chalk.sandbox.v2.CreateSandboxRequest.source
   */
  source: {
    /**
     * @generated from field: chalk.container.v1.ChalkContainerSpec spec = 1;
     */
    value: ChalkContainerSpec;
    case: "spec";
  } | {
    /**
     * Forks use the snapshot's recorded container spec and ignore any caller
     * supplied spec; the snapshot_id is the complete source of truth.
     *
     * @generated from field: string snapshot_id = 2;
     */
    value: string;
    case: "snapshotId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.sandbox.v2.CreateSandboxRequest.
 * Use `create(CreateSandboxRequestSchema)` to create a new message.
 */
export const CreateSandboxRequestSchema: GenMessage<CreateSandboxRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 1);

/**
 * @generated from message chalk.sandbox.v2.CreateSandboxResponse
 */
export type CreateSandboxResponse = Message<"chalk.sandbox.v2.CreateSandboxResponse"> & {
  /**
   * @generated from field: chalk.sandbox.v2.SandboxInfo sandbox = 1;
   */
  sandbox?: SandboxInfo;
};

/**
 * Describes the message chalk.sandbox.v2.CreateSandboxResponse.
 * Use `create(CreateSandboxResponseSchema)` to create a new message.
 */
export const CreateSandboxResponseSchema: GenMessage<CreateSandboxResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 2);

/**
 * @generated from message chalk.sandbox.v2.GetSandboxRequest
 */
export type GetSandboxRequest = Message<"chalk.sandbox.v2.GetSandboxRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.sandbox.v2.GetSandboxRequest.
 * Use `create(GetSandboxRequestSchema)` to create a new message.
 */
export const GetSandboxRequestSchema: GenMessage<GetSandboxRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 3);

/**
 * @generated from message chalk.sandbox.v2.GetSandboxResponse
 */
export type GetSandboxResponse = Message<"chalk.sandbox.v2.GetSandboxResponse"> & {
  /**
   * @generated from field: chalk.sandbox.v2.SandboxInfo sandbox = 1;
   */
  sandbox?: SandboxInfo;
};

/**
 * Describes the message chalk.sandbox.v2.GetSandboxResponse.
 * Use `create(GetSandboxResponseSchema)` to create a new message.
 */
export const GetSandboxResponseSchema: GenMessage<GetSandboxResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 4);

/**
 * @generated from message chalk.sandbox.v2.ListSandboxesFilters
 */
export type ListSandboxesFilters = Message<"chalk.sandbox.v2.ListSandboxesFilters"> & {
  /**
   * @generated from field: repeated string names = 1 [deprecated = true];
   * @deprecated
   */
  names: string[];

  /**
   * @generated from field: repeated chalk.sandbox.v2.SandboxStatus statuses = 2;
   */
  statuses: SandboxStatus[];

  /**
   * @generated from field: repeated string images = 3;
   */
  images: string[];

  /**
   * @generated from field: repeated string created_by = 4;
   */
  createdBy: string[];

  /**
   * Sandboxes whose spec tags include every one of these key/value pairs, e.g.
   * {"chalk.evaluation.run_id": "<run id>"} for the sandboxes of one evaluation run.
   *
   * @generated from field: map<string, string> tags = 5 [deprecated = true];
   * @deprecated
   */
  tags: { [key: string]: string };

  /**
   * Matches the current spec.restore_from_snapshot_id, including forks and resumes.
   * Values are ORed and ANDed with other filters. This is not restore history.
   *
   * @generated from field: repeated string restore_from_snapshot_ids = 6;
   */
  restoreFromSnapshotIds: string[];

  /**
   * Mutually exclusive with legacy tags; ANDed with other filters.
   *
   * @generated from field: optional chalk.common.v1.TagFilter tag_filter = 7;
   */
  tagFilter?: TagFilter;

  /**
   * Sandboxes initially created from any of these snapshots, including after resume.
   *
   * @generated from field: repeated string source_snapshot_ids = 8;
   */
  sourceSnapshotIds: string[];
};

/**
 * Describes the message chalk.sandbox.v2.ListSandboxesFilters.
 * Use `create(ListSandboxesFiltersSchema)` to create a new message.
 */
export const ListSandboxesFiltersSchema: GenMessage<ListSandboxesFilters> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 5);

/**
 * @generated from message chalk.sandbox.v2.ListSandboxesRequest
 */
export type ListSandboxesRequest = Message<"chalk.sandbox.v2.ListSandboxesRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * @generated from field: chalk.sandbox.v2.ListSandboxesFilters filters = 4;
   */
  filters?: ListSandboxesFilters;

  /**
   * @generated from field: chalk.sandbox.v2.SandboxSortColumn sort_column = 5;
   */
  sortColumn: SandboxSortColumn;

  /**
   * @generated from field: chalk.sandbox.v2.SandboxSortOrder sort_order = 6;
   */
  sortOrder: SandboxSortOrder;
};

/**
 * Describes the message chalk.sandbox.v2.ListSandboxesRequest.
 * Use `create(ListSandboxesRequestSchema)` to create a new message.
 */
export const ListSandboxesRequestSchema: GenMessage<ListSandboxesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 6);

/**
 * @generated from message chalk.sandbox.v2.ListSandboxesResponse
 */
export type ListSandboxesResponse = Message<"chalk.sandbox.v2.ListSandboxesResponse"> & {
  /**
   * @generated from field: repeated chalk.sandbox.v2.SandboxInfo sandboxes = 1;
   */
  sandboxes: SandboxInfo[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.sandbox.v2.ListSandboxesResponse.
 * Use `create(ListSandboxesResponseSchema)` to create a new message.
 */
export const ListSandboxesResponseSchema: GenMessage<ListSandboxesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 7);

/**
 * @generated from message chalk.sandbox.v2.SuspendSandboxRequest
 */
export type SuspendSandboxRequest = Message<"chalk.sandbox.v2.SuspendSandboxRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.sandbox.v2.SuspendSandboxRequest.
 * Use `create(SuspendSandboxRequestSchema)` to create a new message.
 */
export const SuspendSandboxRequestSchema: GenMessage<SuspendSandboxRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 8);

/**
 * @generated from message chalk.sandbox.v2.SuspendSandboxResponse
 */
export type SuspendSandboxResponse = Message<"chalk.sandbox.v2.SuspendSandboxResponse"> & {
};

/**
 * Describes the message chalk.sandbox.v2.SuspendSandboxResponse.
 * Use `create(SuspendSandboxResponseSchema)` to create a new message.
 */
export const SuspendSandboxResponseSchema: GenMessage<SuspendSandboxResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 9);

/**
 * @generated from message chalk.sandbox.v2.ResumeSandboxRequest
 */
export type ResumeSandboxRequest = Message<"chalk.sandbox.v2.ResumeSandboxRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.sandbox.v2.ResumeSandboxRequest.
 * Use `create(ResumeSandboxRequestSchema)` to create a new message.
 */
export const ResumeSandboxRequestSchema: GenMessage<ResumeSandboxRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 10);

/**
 * @generated from message chalk.sandbox.v2.ResumeSandboxResponse
 */
export type ResumeSandboxResponse = Message<"chalk.sandbox.v2.ResumeSandboxResponse"> & {
};

/**
 * Describes the message chalk.sandbox.v2.ResumeSandboxResponse.
 * Use `create(ResumeSandboxResponseSchema)` to create a new message.
 */
export const ResumeSandboxResponseSchema: GenMessage<ResumeSandboxResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 11);

/**
 * @generated from message chalk.sandbox.v2.TerminateSandboxRequest
 */
export type TerminateSandboxRequest = Message<"chalk.sandbox.v2.TerminateSandboxRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Grace period before the container is killed. Defaults to the server's
   * configured grace period when unset.
   *
   * @generated from field: optional google.protobuf.Duration grace_period = 2;
   */
  gracePeriod?: Duration;
};

/**
 * Describes the message chalk.sandbox.v2.TerminateSandboxRequest.
 * Use `create(TerminateSandboxRequestSchema)` to create a new message.
 */
export const TerminateSandboxRequestSchema: GenMessage<TerminateSandboxRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 12);

/**
 * @generated from message chalk.sandbox.v2.TerminateSandboxResponse
 */
export type TerminateSandboxResponse = Message<"chalk.sandbox.v2.TerminateSandboxResponse"> & {
};

/**
 * Describes the message chalk.sandbox.v2.TerminateSandboxResponse.
 * Use `create(TerminateSandboxResponseSchema)` to create a new message.
 */
export const TerminateSandboxResponseSchema: GenMessage<TerminateSandboxResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 13);

/**
 * @generated from message chalk.sandbox.v2.SandboxResource
 */
export type SandboxResource = Message<"chalk.sandbox.v2.SandboxResource"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sandbox_id = 2;
   */
  sandboxId: string;

  /**
   * @generated from field: chalk.sandbox.v2.SandboxResourceKind kind = 3;
   */
  kind: SandboxResourceKind;

  /**
   * @generated from field: string resource_id = 4;
   */
  resourceId: string;

  /**
   * Empty for resources without an independently addressable version.
   *
   * @generated from field: string version_id = 5;
   */
  versionId: string;

  /**
   * First capture time. Retained when the same operation is observed again.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string agent_id = 7;
   */
  agentId: string;

  /**
   * Current display name, when available in metadata. Absent for unnamed or missing resources.
   *
   * @generated from field: optional string name = 8;
   */
  name?: string;
};

/**
 * Describes the message chalk.sandbox.v2.SandboxResource.
 * Use `create(SandboxResourceSchema)` to create a new message.
 */
export const SandboxResourceSchema: GenMessage<SandboxResource> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 14);

/**
 * @generated from message chalk.sandbox.v2.ListSandboxResourcesFilters
 */
export type ListSandboxResourcesFilters = Message<"chalk.sandbox.v2.ListSandboxResourcesFilters"> & {
  /**
   * @generated from field: repeated chalk.sandbox.v2.SandboxResourceKind kinds = 1;
   */
  kinds: SandboxResourceKind[];

  /**
   * @generated from field: repeated string resource_ids = 2;
   */
  resourceIds: string[];

  /**
   * Inclusive lower bound and exclusive upper bound on first capture time.
   *
   * @generated from field: google.protobuf.Timestamp created_after = 3;
   */
  createdAfter?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_before = 4;
   */
  createdBefore?: Timestamp;
};

/**
 * Describes the message chalk.sandbox.v2.ListSandboxResourcesFilters.
 * Use `create(ListSandboxResourcesFiltersSchema)` to create a new message.
 */
export const ListSandboxResourcesFiltersSchema: GenMessage<ListSandboxResourcesFilters> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 15);

/**
 * @generated from message chalk.sandbox.v2.ListSandboxResourcesRequest
 */
export type ListSandboxResourcesRequest = Message<"chalk.sandbox.v2.ListSandboxResourcesRequest"> & {
  /**
   * @generated from field: string sandbox_id = 1;
   */
  sandboxId: string;

  /**
   * @generated from field: chalk.sandbox.v2.ListSandboxResourcesFilters filters = 2;
   */
  filters?: ListSandboxResourcesFilters;

  /**
   * Defaults to 50. Must be between 0 and 200.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * Opaque cursor. Sandbox and filters must match the first request.
   *
   * @generated from field: string page_token = 4;
   */
  pageToken: string;
};

/**
 * Describes the message chalk.sandbox.v2.ListSandboxResourcesRequest.
 * Use `create(ListSandboxResourcesRequestSchema)` to create a new message.
 */
export const ListSandboxResourcesRequestSchema: GenMessage<ListSandboxResourcesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 16);

/**
 * @generated from message chalk.sandbox.v2.ListSandboxResourcesResponse
 */
export type ListSandboxResourcesResponse = Message<"chalk.sandbox.v2.ListSandboxResourcesResponse"> & {
  /**
   * Newest first, ordered by (created_at, id). References survive deletion of
   * their source resource and do not grant permission to read that resource.
   * Query references survive execution-history expiration. Capture covers Go API
   * entry points and is best effort for queries observed after acceptance/execution.
   *
   * @generated from field: repeated chalk.sandbox.v2.SandboxResource resources = 1;
   */
  resources: SandboxResource[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message chalk.sandbox.v2.ListSandboxResourcesResponse.
 * Use `create(ListSandboxResourcesResponseSchema)` to create a new message.
 */
export const ListSandboxResourcesResponseSchema: GenMessage<ListSandboxResourcesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 17);

/**
 * @generated from message chalk.sandbox.v2.RecordSandboxResourceRequest
 */
export type RecordSandboxResourceRequest = Message<"chalk.sandbox.v2.RecordSandboxResourceRequest"> & {
  /**
   * @generated from field: chalk.sandbox.v2.SandboxResourceKind kind = 1;
   */
  kind: SandboxResourceKind;

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;

  /**
   * @generated from field: string version_id = 3;
   */
  versionId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;
};

/**
 * Describes the message chalk.sandbox.v2.RecordSandboxResourceRequest.
 * Use `create(RecordSandboxResourceRequestSchema)` to create a new message.
 */
export const RecordSandboxResourceRequestSchema: GenMessage<RecordSandboxResourceRequest> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 18);

/**
 * @generated from message chalk.sandbox.v2.RecordSandboxResourceResponse
 */
export type RecordSandboxResourceResponse = Message<"chalk.sandbox.v2.RecordSandboxResourceResponse"> & {
};

/**
 * Describes the message chalk.sandbox.v2.RecordSandboxResourceResponse.
 * Use `create(RecordSandboxResourceResponseSchema)` to create a new message.
 */
export const RecordSandboxResourceResponseSchema: GenMessage<RecordSandboxResourceResponse> = /*@__PURE__*/
  messageDesc(file_chalk_sandbox_v2_service, 19);

/**
 * @generated from enum chalk.sandbox.v2.SandboxStatus
 */
export enum SandboxStatus {
  /**
   * @generated from enum value: SANDBOX_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SANDBOX_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: SANDBOX_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: SANDBOX_STATUS_SUCCEEDED = 3;
   */
  SUCCEEDED = 3,

  /**
   * @generated from enum value: SANDBOX_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: SANDBOX_STATUS_TERMINATED = 5;
   */
  TERMINATED = 5,

  /**
   * @generated from enum value: SANDBOX_STATUS_ERROR = 6;
   */
  ERROR = 6,

  /**
   * @generated from enum value: SANDBOX_STATUS_UNKNOWN = 7;
   */
  UNKNOWN = 7,

  /**
   * @generated from enum value: SANDBOX_STATUS_SUSPENDED = 8;
   */
  SUSPENDED = 8,
}

/**
 * Describes the enum chalk.sandbox.v2.SandboxStatus.
 */
export const SandboxStatusSchema: GenEnum<SandboxStatus> = /*@__PURE__*/
  enumDesc(file_chalk_sandbox_v2_service, 0);

/**
 * @generated from enum chalk.sandbox.v2.SandboxSortColumn
 */
export enum SandboxSortColumn {
  /**
   * @generated from enum value: SANDBOX_SORT_COLUMN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SANDBOX_SORT_COLUMN_CREATED_AT = 1;
   */
  CREATED_AT = 1,
}

/**
 * Describes the enum chalk.sandbox.v2.SandboxSortColumn.
 */
export const SandboxSortColumnSchema: GenEnum<SandboxSortColumn> = /*@__PURE__*/
  enumDesc(file_chalk_sandbox_v2_service, 1);

/**
 * @generated from enum chalk.sandbox.v2.SandboxSortOrder
 */
export enum SandboxSortOrder {
  /**
   * @generated from enum value: SANDBOX_SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SANDBOX_SORT_ORDER_DESC = 1;
   */
  DESC = 1,

  /**
   * @generated from enum value: SANDBOX_SORT_ORDER_ASC = 2;
   */
  ASC = 2,
}

/**
 * Describes the enum chalk.sandbox.v2.SandboxSortOrder.
 */
export const SandboxSortOrderSchema: GenEnum<SandboxSortOrder> = /*@__PURE__*/
  enumDesc(file_chalk_sandbox_v2_service, 2);

/**
 * A durable reference to a resource produced using sandbox credentials.
 * Query references identify observed operations, not execution success.
 * Function references identify versions.
 *
 * @generated from enum chalk.sandbox.v2.SandboxResourceKind
 */
export enum SandboxResourceKind {
  /**
   * @generated from enum value: SANDBOX_RESOURCE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SANDBOX_RESOURCE_KIND_NOTEBOOK = 1;
   */
  NOTEBOOK = 1,

  /**
   * @generated from enum value: SANDBOX_RESOURCE_KIND_CHALKCOMPUTE_FUNCTION = 2;
   */
  CHALKCOMPUTE_FUNCTION = 2,

  /**
   * @generated from enum value: SANDBOX_RESOURCE_KIND_ONLINE_QUERY = 3;
   */
  ONLINE_QUERY = 3,

  /**
   * @generated from enum value: SANDBOX_RESOURCE_KIND_OFFLINE_QUERY = 4;
   */
  OFFLINE_QUERY = 4,

  /**
   * @generated from enum value: SANDBOX_RESOURCE_KIND_SQL_QUERY = 5;
   */
  SQL_QUERY = 5,

  /**
   * @generated from enum value: SANDBOX_RESOURCE_KIND_STORED_ARTIFACT = 6;
   */
  STORED_ARTIFACT = 6,

  /**
   * A GitHub pull request opened from the sandbox. resource_id is the PR URL.
   *
   * @generated from enum value: SANDBOX_RESOURCE_KIND_GITHUB_PR = 7;
   */
  GITHUB_PR = 7,
}

/**
 * Describes the enum chalk.sandbox.v2.SandboxResourceKind.
 */
export const SandboxResourceKindSchema: GenEnum<SandboxResourceKind> = /*@__PURE__*/
  enumDesc(file_chalk_sandbox_v2_service, 3);

/**
 * @generated from service chalk.sandbox.v2.SandboxService
 */
export const SandboxService: GenService<{
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxService.CreateSandbox
   */
  createSandbox: {
    methodKind: "unary";
    input: typeof CreateSandboxRequestSchema;
    output: typeof CreateSandboxResponseSchema;
  },
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxService.GetSandbox
   */
  getSandbox: {
    methodKind: "unary";
    input: typeof GetSandboxRequestSchema;
    output: typeof GetSandboxResponseSchema;
  },
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxService.ListSandboxes
   */
  listSandboxes: {
    methodKind: "unary";
    input: typeof ListSandboxesRequestSchema;
    output: typeof ListSandboxesResponseSchema;
  },
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxService.SuspendSandbox
   */
  suspendSandbox: {
    methodKind: "unary";
    input: typeof SuspendSandboxRequestSchema;
    output: typeof SuspendSandboxResponseSchema;
  },
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxService.ResumeSandbox
   */
  resumeSandbox: {
    methodKind: "unary";
    input: typeof ResumeSandboxRequestSchema;
    output: typeof ResumeSandboxResponseSchema;
  },
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxService.TerminateSandbox
   */
  terminateSandbox: {
    methodKind: "unary";
    input: typeof TerminateSandboxRequestSchema;
    output: typeof TerminateSandboxResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_sandbox_v2_service, 0);

/**
 * @generated from service chalk.sandbox.v2.SandboxResourceService
 */
export const SandboxResourceService: GenService<{
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxResourceService.ListSandboxResources
   */
  listSandboxResources: {
    methodKind: "unary";
    input: typeof ListSandboxResourcesRequestSchema;
    output: typeof ListSandboxResourcesResponseSchema;
  },
  /**
   * @generated from rpc chalk.sandbox.v2.SandboxResourceService.RecordSandboxResource
   */
  recordSandboxResource: {
    methodKind: "unary";
    input: typeof RecordSandboxResourceRequestSchema;
    output: typeof RecordSandboxResourceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_sandbox_v2_service, 1);

